import { Badge } from "@via/components/badge.tsx";
import { BadgeStatus } from "@via/utils/constants.tsx";
import { ExecutionVisibility } from "common";

const DEFAULT_UNREACHABLE_TITLE =
  "The run environment has stopped answering status polls. The last known status may be stale.";

/**
 * Spec 17: execution visibility is a separate axis from run status, and the run is NOT failed
 * when it goes unreachable, so this always uses the warning (amber) styling `getRunStatusLabel`
 * reserves for in-progress states, never the error (red) styling. Silent for every other
 * visibility value, including the common `visible` case and a response from a server that
 * predates this field.
 *
 * Placement note (run.tsx): render this OUTSIDE the `!isUserViewer` action guard. Visibility is
 * informational, not a mutation privilege, so a read-only viewer must see it too.
 */
export const ExecutionVisibilityBadge = ({
  visibility,
  reason,
}: {
  visibility?: ExecutionVisibility;
  reason?: string | null;
}) => {
  if (visibility !== ExecutionVisibility.Unreachable) return null;

  return (
    <span title={reason ?? DEFAULT_UNREACHABLE_TITLE}>
      <Badge
        text="Unreachable"
        fillColor={BadgeStatus.WaitingFillColor}
        textColor={BadgeStatus.WaitingTextColor}
      />
    </span>
  );
};
